{
  "page_Reseptformidleren_NavigateBackLinkTitle": "til Helseregistre",
  "page_Reseptformidleren_NavigateBackLinkURL": "/helseregistre",
  "page_Helseregistre_NavigateBackLinkTitle": "til Helseregistre",
  "page_Helseregistre_NavigateBackLinkURL": "/helseregistre",
  "page_Samvalg_NavigateBackLinkTitle": "Samvalg",
  "page_Samvalg_NavigateBackLinkURL": "{HelsenorgeUrl}/samvalg",
  "page_VelgBehandlingssted_NavigateBackLinkTitle": "Velg behandlingssted",
  "page_Behandlinger_NavigateBackLinkTitle": "Behandlinger"
}
